import * as React from 'react';

// props for progress bar
interface IProgessBarProps {
    maxValue:number;
    currentValue:number;
    message:string;
}

/**
 * Container where all logic for the progress bar is stored
 */

export class ProgressBar extends React.Component<IProgessBarProps, any> {

    public render():any {

        let progressPercent:number = Math.round(((this.props.maxValue-this.props.currentValue)/this.props.maxValue)*100);
        let progressBarStyle:any = {width: progressPercent+'%'};
        let progressMessage:string = this.props.message.replace(/ /g, "\u00a0");

        return (
            <div className="progress-border" style={{width:"inherit"}}>
                <div className="progress-bar" style={progressBarStyle}>
                    <div className="progress-message">
                        {progressMessage}
                    </div>
                </div>
            </div>
        );
    }

}



